"use strict";

var _defineProperty = require("/agent/_work/1/s/node_modules/@babel/runtime/helpers/defineProperty.js");
var _toConsumableArray = require("/agent/_work/1/s/node_modules/@babel/runtime/helpers/toConsumableArray.js");
var _slicedToArray = require("/agent/_work/1/s/node_modules/@babel/runtime/helpers/slicedToArray.js");
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  result["default"] = mod;
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var Hook = __importStar(require("../forms/use-form"));
function createUseFormHelper(sandbox, UseFormWrapper, initialData) {
  var fieldAdapter = sandbox.stub();
  var formData = Object.assign({}, initialData);
  var formState = Hook.stateFromInitialForm(formData);
  var valueQueue = [];
  var errorQueue = [];
  var formIsValid = false;
  var submitAdapter = function submitAdapter(cb) {
    return function () {
      return cb(formIsValid, formData, formState);
    };
  };
  var attachedWrapper;
  fieldAdapter.callsFake(function (props) {
    return {
      value: formData[props.name],
      name: props.name,
      onChange: props.onChange,
      onBlur: props.onBlur
    };
  });
  var resetForm = sandbox.stub();
  var deleteFormDraft = sandbox.stub();
  var useForm = sandbox.stub(UseFormWrapper, "useForm").returns({
    formState: formState,
    formData: formData,
    fieldAdapter: fieldAdapter,
    submitAdapter: submitAdapter,
    formHasErrors: formHasErrors,
    setValue: setValue,
    setMultipleValues: setMultipleValues,
    resetForm: resetForm,
    deleteFormDraft: deleteFormDraft
  });
  return {
    useForm: useForm,
    getAdapterArgs: getAdapterArgs,
    validateOn: validateOn,
    getConditionalFields: getConditionalFields,
    getRequiredFields: getRequiredFields,
    setValue: setValue,
    setMultipleValues: setMultipleValues,
    resetForm: resetForm,
    setError: setError,
    attachShallowWrapper: attachShallowWrapper,
    setFormValid: setFormValid,
    deleteFormDraft: deleteFormDraft,
    triggerOnDraftSaved: triggerOnDraftSaved
  };
  function setFormValid(status) {
    formIsValid = status;
  }
  function formHasErrors() {
    return !formIsValid;
  }
  function attachShallowWrapper(wrapper) {
    attachedWrapper = wrapper;
    if (valueQueue.length) {
      valueQueue.forEach(function (value) {
        formData[value.name] = value.value;
      });
      valueQueue = [];
    }
    if (errorQueue.length) {
      errorQueue.forEach(function (value) {
        formState[value.name].errors = value.error;
      });
      errorQueue = [];
    }
    attachedWrapper.setProps(Object.assign({}, attachedWrapper.props()));
    attachedWrapper.update();
  }
  function setError(name, error) {
    if (attachedWrapper) {
      formState[name].errors = error;
      attachedWrapper.setProps(Object.assign({}, attachedWrapper.props()));
      attachedWrapper.update();
    } else {
      errorQueue.push({
        name: name,
        error: error
      });
    }
  }
  function triggerOnDraftSaved() {
    var draftInfo = useForm.lastCall.args[1];
    draftInfo && draftInfo.onDraftSaved && draftInfo.onDraftSaved();
  }
  function setMultipleValues(values) {
    if (attachedWrapper) {
      Object.entries(values).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        formData[key] = value;
      });
      attachedWrapper.setProps(Object.assign({}, attachedWrapper.props()));
      attachedWrapper.update();
    } else {
      var _valueQueue;
      var temp = Object.entries(values).map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          name = _ref4[0],
          value = _ref4[1];
        return {
          name: name,
          value: value
        };
      });
      (_valueQueue = valueQueue).push.apply(_valueQueue, _toConsumableArray(temp));
    }
  }
  function setValue(name, value) {
    if (attachedWrapper) {
      formData[name] = value;
      attachedWrapper.setProps(Object.assign({}, attachedWrapper.props()));
      attachedWrapper.update();
    } else {
      valueQueue.push({
        name: name,
        value: value
      });
    }
  }
  function getAdapterArgs(name) {
    var call = fieldAdapter.getCalls().reverse().find(function (call) {
      return call.args[0].name === name;
    });
    if (!call) {
      throw Error("No field adapter for field named \"".concat(name));
    }
    return call.args[0];
  }
  function validateOn(name, value) {
    var validate = getAdapterArgs(name).validate;
    if (!validate) {
      throw Error("No validate function exists for \"".concat(name, "\""));
    }
    return validate(value, formData, formState);
  }
  function getConditionalFields() {
    return fieldAdapter.getCalls().map(function (call) {
      return call.args[0];
    }).filter(function (options) {
      return options.condition !== undefined;
    }).reduce(function (fields, options) {
      return Object.assign(Object.assign({}, fields), _defineProperty({}, options.name, options.condition));
    }, {});
  }
  function getRequiredFields() {
    return fieldAdapter.getCalls().map(function (call) {
      return call.args[0];
    }).filter(function (options) {
      return options.required !== undefined;
    }).reduce(function (fields, options) {
      return Object.assign(Object.assign({}, fields), _defineProperty({}, options.name, options.required));
    }, {});
  }
}
exports.createUseFormHelper = createUseFormHelper;